import { render, staticRenderFns } from "./StrategyRelated.vue?vue&type=template&id=d3293cbe"
import script from "./StrategyRelated.vue?vue&type=script&lang=js"
export * from "./StrategyRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports